// Lock pinch-zoom on touch devices — chiefly iOS Safari, which deliberately
// ignores `user-scalable=no` / `maximum-scale` in the viewport meta (Apple
// re-enabled pinch-zoom for accessibility since iOS 10). This game is a fixed,
// HUD-dense layout that breaks visually when scaled, so we suppress the gesture.
//
// Double-tap-zoom is handled by `touch-action: manipulation` in index.css;
// here we only cancel the actual pinch gestures. Single-finger scroll, taps and
// drags (sliders, buttons) are left untouched.
export function lockZoom() {
  const prevent = (e: Event) => e.preventDefault()

  // iOS Safari surfaces pinch via non-standard gesture* events on `document`.
  document.addEventListener('gesturestart', prevent, { passive: false })
  document.addEventListener('gesturechange', prevent, { passive: false })
  document.addEventListener('gestureend', prevent, { passive: false })

  // Browsers that fire standard touch events: cancel multi-touch moves only,
  // so one-finger panning/scrolling keeps working.
  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches.length > 1) e.preventDefault()
    },
    { passive: false },
  )

  // Ctrl/Cmd + wheel pinch zoom (trackpads, hybrid devices).
  document.addEventListener(
    'wheel',
    (e) => {
      if (e.ctrlKey) e.preventDefault()
    },
    { passive: false },
  )
}
